import _ from 'lodash'
import FormType from 'scoreboard/forms/model/form-type'
const { FORM } = FormType

function getParentForm(tree, id) {
	let node = tree.get(id)
	while (!_.isNil(node) && node.type != FORM) {
		// #55484 when dragging, need to get the original parentId
		let parentId = node.beforeDragState?.parentId ?? node.parentId
		// #55531 folders may not have a form above them
		if (_.isNil(parentId)) {
			return null
		}
		node = tree.get(parentId)
	}
	return node
}

export default getParentForm

getParentForm.__filename__ = 'forms/get-parent-form.js'
